import angular from 'angular';

/**
 * @ngdoc service
 * @name app.fromMail
 * @description
 * @deprecated
 * Factory fromMail treatment.
 */
angular.module('app')
	.factory('fromMail', /* @ngInject */ ($q, $uibModal, API, User) => {
		// element of redirect are either url or
		// {act: act, ref: ref } elements. with act = WF | PV
		const redirect = [];

		const canRedirect = () => (User.logged() && (redirect.length > 0));

		const push = element => {
			redirect.push(element);
		};

		const pop = () => {
			const deferred = $q.defer();
			const route = redirect.pop();
			if (typeof route === 'string') {
				deferred.resolve(route);
			}
			else {
				//
				if (route.act === 'PV') {
					deferred.resolve(`/preview/K_NODE;${route.ref}`);

					// localhost:7000/identify?act=WF&amp;ref=0000005LMF6HHKB400
				}
				else if (route.act === 'WF') {
					API.wfAffectTodo(`K_NODE;${route.ref}`).then(data => {
						data.joblist[1] = angular.copy(data.joblist[0]);

						if (data.joblist.length === 0) {
							deferred.reject({});
						}
						else if (data.joblist.length === 1) {
							deferred.resolve(`/workflow/${data.joblist[0].job_kid}`);
						}
						else {
							const modalInstance = $uibModal.open({
								templateUrl: 'templates/modal/workflow-choose.html',
								controller:  'WfModalCtrl',
								resolve:     {
									joblist() {
										return data;
									},
								},
							});

							modalInstance.result.then(jobKid => {
								deferred.resolve(`/workflow/${jobKid}`);
							});
						}
					}, error => {
						deferred.reject(error);
					});
				}
				else {
					deferred.reject({ error: null });
				}
			}
			return deferred.promise;
		};

		return {
			push,
			pop,
			is: canRedirect,
		};
	})

	.controller('WfModalCtrl', /* @ngInject */ ($scope, $uibModalInstance, joblist) => {
		$scope.joblist = joblist;

		$scope.$on('close-popin', (event, job_kid) => {
			$uibModalInstance.close(job_kid);
		});
	});
